module.exports = __webpack_public_path__ + "static/The Sceens - Perspective PSD Mockup - by Tranmautritam3-e12f2c28ff9f8313f15e07d79ff33b22.png";